import { useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Gallery from "../components/Gallery";
import Certificates from "../components/Certificates";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import SectionPattern from "../components/ui/SectionPattern";
import SEO from "../components/SEO";
import { useSettings } from "../contexts/SettingsContext";

const HomePage = () => {
  const { sectionSettings } = useSettings();

  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = "smooth";

    return () => {
      document.documentElement.style.scrollBehavior = "auto";
    };
  }, []);

  // Schema.org structured data
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Putri Henna Artist",
    description:
      "Layanan henna profesional khusus acara pernikahan. Melayani henna wedding untuk pengantin hingga henna fun untuk bridesmaid, pagar ayu, dan keluarga pengantin di area Sumedang.",
    url: "https://tehputrihenna.com",
    telephone: "+6289526775445",
    image: "https://tehputrihenna.com/banner.webp",
    founder: {
      "@type": "Person",
      name: "Putri Leony Nur R, S.E",
    },
    areaServed: {
      "@type": "City",
      name: "Sumedang",
    },
    address: {
      "@type": "PostalAddress",
      addressCountry: "ID",
      addressLocality: "Sumedang",
    },
    priceRange: "$$",
    sameAs: [
      "https://www.instagram.com/tehputri_henna",
      "https://www.facebook.com/tehputrihenna",
    ],
    serviceType: [
      "Henna Wedding",
      "Henna Engagement",
      "Henna Prewedding",
      "Henna Pagar Ayu",
      "Henna Bridesmaid",
      "Henna Graduation",
      "Fun Henna",
    ],
  };

  return (
    <div className="min-h-screen bg-black">
      <SEO
        title="Putri Henna | Jasa Henna Profesional untuk Acara Spesial"
        description="Layanan henna profesional untuk wedding, engagement, tunangan, dan acara spesial lainnya. Pilihan paket terlengkap dengan artist berpengalaman."
        keywords="henna wedding, henna engagement, jasa henna, henna artist, henna profesional, henna tunangan, henna pesta"
        url="https://tehputrihenna.com"
        schema={schema}
      />
      <Header />
      <main>
        <Hero />
        {sectionSettings.about && (
          <>
            <SectionPattern variant="mandala" className="py-2" />
            <About />
          </>
        )}
        {sectionSettings.services && (
          <>
            <SectionPattern variant="vine" className="py-2" />
            <Services />
          </>
        )}
        {sectionSettings.gallery && (
          <>
            <SectionPattern variant="border" className="py-2" />
            <Gallery />
          </>
        )}
        {sectionSettings.certificates && (
          <>
            <SectionPattern variant="corner" className="py-2" />
            <Certificates />
          </>
        )}
        {sectionSettings.testimonials && (
          <>
            <SectionPattern variant="mandala" className="py-2" />
            <Testimonials />
          </>
        )}
        {sectionSettings.contact && (
          <>
            <SectionPattern variant="vine" className="py-2" />
            <Contact />
          </>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
